import { render, staticRenderFns } from "./s10.vue?vue&type=template&id=86cb9c28&scoped=true"
import script from "./s10.vue?vue&type=script&lang=js"
export * from "./s10.vue?vue&type=script&lang=js"
import style0 from "./s10.vue?vue&type=style&index=0&id=86cb9c28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86cb9c28",
  null
  
)

export default component.exports